import Axios from '../config/Axios';
import verifyToken from '../config/verifyToken';

export async function login(email, password){	
	const response = await Axios.post('auth/login', {email, password});		
	return response;
}

export async function verifyAuth(){
	verifyToken();
	const response = await Axios.get('auth/verify-auth');
	return response;
}

export function logout(){
	localStorage.removeItem('token');
}